export default "__VITE_PUBLIC_ASSET__5dea2586__"